function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from "react";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import moment from "moment-timezone";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form, Formik, FieldArray, getIn } from "formik";
import * as Yup from "yup";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import { FilterContext, UserContext, SearchContext } from "../index";
import { ADD_PERSONAL_TASK_DETAILS_MUTATION, PERSONAL_TASK_DETAILS, DELETE_TASK_MUTATION, EDIT_TASK_DETAILS_MUTATION, UPDATE_PERSONAL_TASK_STATUS_MUTATION, PERSONAL_TASK_COUNT_DETAILS } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import Loader from "./../Loader/Loader";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toast } from "react-toastify";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import ProgressBar from "react-bootstrap/ProgressBar";
/* edit-project */
import { MdAddCircleOutline, MdCheck } from "react-icons/md";
import "./CreateProject.css";
import "./MyProjects.css";
import "./PersonalTask.css";
import { PROJECT_LISTING_QUERY } from "./../SideMenu/query";
import InputGroup from "react-bootstrap/InputGroup";
import { VscLoading } from "react-icons/vsc";
import Profile from "../img/profile/little-girl.png";
import { arrayToStringOutput } from "./../SideMenu/Header";
import SearchBar from "../SearchBar";
import { MdAccessTime, MdAdd } from "react-icons/md";
import { WEB_ORGANISATION_SETTINGS_QUERY, WORK_DAY_SETTINGS_QUERY } from "../TimesheetSettings/query";
import { TASK_OVERVIEW_SUMMARY_DATA_QUERY } from "../TaskOverview/query";
import { GET_TASK_TRACKER_QUERY, TASK_USERS_QUERY } from "../ManualPages/query";
import { PROJECT_DETAILS_SUMMARY_QUERY, ADD_TASK_DETAILS_MUTATION, ADD_USER_TASK_DETAILS_MUTATION } from "../ProjectDetails/query";
import { FaRegFolderOpen } from "react-icons/fa";
import { FiCheckSquare, FiAlertTriangle, FiMoreHorizontal, FiUsers, FiCalendar, FiEdit } from "react-icons/fi";
import { IoMdCheckmarkCircleOutline, IoMdPersonAdd } from "react-icons/io";
import Badge from "react-bootstrap/Badge";
import Dropdown from "react-bootstrap/Dropdown";
import { HiOutlineDotsVertical } from "react-icons/hi";
import Select from "react-select";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { HiLockClosed } from "react-icons/hi";
import Accordion from "react-bootstrap/Accordion";
import DatePicker from "react-datepicker";
import Table from "react-bootstrap/Table";
import { RiDeleteBinLine, RiTimerLine, RiFileChartLine } from "react-icons/ri";
var LIMIT = 10;
var personalTaskSchema = Yup.object().shape({
  taskName: Yup.string().trim().required("Required")
});
export var PersonalTask = function PersonalTask(props) {
  var organisationId = props.organisationId,
    tableView = props.tableView;
  var shouldFetch = tableView === "personal-tasks"; // or from parent prop

  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useState = React.useState({
      label: "All Priorities",
      value: "all"
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectPriorityFilter = _React$useState2[0],
    setSelectPriorityFilter = _React$useState2[1];
  var _React$useState3 = React.useState("all"),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    filterPriorityId = _React$useState4[0],
    setFilterPriorityId = _React$useState4[1];
  var _React$useState5 = React.useState({
      label: "All Status",
      value: "all"
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectStatusFilter = _React$useState6[0],
    setSelectStatusFilter = _React$useState6[1];
  var _React$useState7 = React.useState("all"),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    filterStatusId = _React$useState8[0],
    setFilterStatusId = _React$useState8[1];
  // add task
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    addTaskShow = _React$useState10[0],
    setAddTaskShow = _React$useState10[1];
  //delete task
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    showTaskDeleteModal = _React$useState12[0],
    setShowDeleteTaskModal = _React$useState12[1];
  //edit task
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    taskDetails = _React$useState14[0],
    setShowNewTaskModal = _React$useState14[1];
  var priorityOptionList = [{
    label: "All Priorities",
    value: "all"
  }, {
    label: "High",
    value: "high"
  }, {
    label: "Medium",
    value: "medium"
  }, {
    label: "Low",
    value: "low"
  }];
  var statusOptionList = [{
    label: "All Status",
    value: "all"
  }, {
    label: "ToDo",
    value: "toDo"
  }, {
    label: "In Progress",
    value: "inProgress"
  }, {
    label: "On Hold",
    value: "onHold"
  }, {
    label: "Completed",
    value: "completed"
  }];
  var _useQuery = useQuery(PERSONAL_TASK_COUNT_DETAILS, {
      variables: {
        organisationId: organisationId,
        priority: filterPriorityId,
        status: filterStatusId
      },
      skip: !shouldFetch || !organisationId
    }),
    personalTaskCountData = _useQuery.data,
    personalTaskCountError = _useQuery.error,
    personalTaskCountLoading = _useQuery.loading,
    personalTaskCountRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(PERSONAL_TASK_DETAILS, {
      variables: {
        organisationId: organisationId,
        limit: LIMIT,
        offset: 0,
        priority: filterPriorityId,
        status: filterStatusId
      },
      skip: !shouldFetch || !organisationId
    }),
    personalTaskData = _useQuery2.data,
    personalTaskError = _useQuery2.error,
    personalTaskLoading = _useQuery2.loading,
    personalTaskRefetch = _useQuery2.refetch,
    personalTaskFetchMore = _useQuery2.fetchMore;
  React.useEffect(function () {
    if (!shouldFetch || !organisationId) return;
    personalTaskRefetch();
    personalTaskCountRefetch();
  }, [filterPriorityId, filterStatusId, organisationId]);

  //add
  var handleTaskShow = function handleTaskShow() {
    setAddTaskShow(user === null || user === void 0 ? void 0 : user.userId);
  };
  var handleTaskClose = function handleTaskClose() {
    setAddTaskShow(null);
  };

  //delete 
  var handleTaskDeleteClose = function handleTaskDeleteClose() {
    return setShowDeleteTaskModal(false);
  };
  var handleTaskDeleteShow = function handleTaskDeleteShow(taskId) {
    return setShowDeleteTaskModal({
      taskId: taskId
    });
  };

  //edit
  var handleShow = function handleShow(taskId, dueDate, taskName, taskStatus, priority) {
    var temp = {
      taskId: taskId,
      dueDate: dueDate,
      taskName: taskName,
      taskStatuss: taskStatus,
      priority: priority
    };
    setShowNewTaskModal(temp);
  };
  var handleClose = function handleClose() {
    return setShowNewTaskModal(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "personal-task-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-task-whole-div-heders"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-task-whole-div-heders-text"
  }, "Personal Tasks (", personalTaskCountLoading ? /*#__PURE__*/React.createElement("span", {
    className: "personal-task-whole-div-heders-text-loader"
  }, "Loading...") : personalTaskCountData === null || personalTaskCountData === void 0 ? void 0 : personalTaskCountData.getPersonalTaskCount, ")"), /*#__PURE__*/React.createElement("div", {
    className: "personal-task-whole-div-heders-filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-user-activity-project-filter"
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectPriorityFilter,
    onChange: function onChange(e) {
      setSelectPriorityFilter(e);
      setFilterPriorityId(e.value);
    },
    options: priorityOptionList,
    className: "task-overview-my-task-user-select",
    classNamePrefix: "Filter By User"
  })), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-user-activity-project-filter"
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectStatusFilter,
    onChange: function onChange(e) {
      setSelectStatusFilter(e);
      setFilterStatusId(e.value);
    },
    options: statusOptionList,
    className: "task-overview-my-task-user-select",
    classNamePrefix: "Filter By User"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "personal-task-add-button-root-new",
    onClick: function onClick() {
      handleTaskShow();
    }
  }, "+ Add Task"))), /*#__PURE__*/React.createElement(PersonalTaskTable, {
    personalTaskData: personalTaskData,
    personalTaskError: personalTaskError,
    personalTaskLoading: personalTaskLoading,
    personalTaskFetchMore: personalTaskFetchMore,
    handleTaskDeleteShow: handleTaskDeleteShow,
    handleShow: handleShow,
    filterPriorityId: filterPriorityId,
    filterStatusId: filterStatusId,
    organisationId: organisationId
  })), /*#__PURE__*/React.createElement(AddTaskModal, {
    addTaskShow: addTaskShow,
    setAddTaskShow: setAddTaskShow,
    handleTaskClose: handleTaskClose,
    organisationId: organisationId,
    filterPriorityId: filterPriorityId,
    filterStatusId: filterStatusId
  }), /*#__PURE__*/React.createElement(DeleteTaskModal, {
    showTaskDeleteModal: showTaskDeleteModal,
    handleTaskDeleteClose: handleTaskDeleteClose,
    organisationId: organisationId,
    filterPriorityId: filterPriorityId,
    filterStatusId: filterStatusId
  }), /*#__PURE__*/React.createElement(TaskModal, {
    taskDetails: taskDetails,
    handleClose: handleClose,
    organisationId: organisationId,
    filterPriorityId: filterPriorityId,
    filterStatusId: filterStatusId
  }));
};
var PersonalTaskTable = function PersonalTaskTable(props) {
  var _personalTaskData$get2, _personalTaskData$get3, _personalTaskData$get4, _personalTaskData$get5;
  var personalTaskData = props.personalTaskData,
    personalTaskError = props.personalTaskError,
    personalTaskLoading = props.personalTaskLoading,
    personalTaskFetchMore = props.personalTaskFetchMore,
    handleTaskDeleteShow = props.handleTaskDeleteShow,
    handleShow = props.handleShow,
    filterPriorityId = props.filterPriorityId,
    filterStatusId = props.filterStatusId,
    organisationId = props.organisationId;
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isTaskAllLoaded = _React$useState16[0],
    setTaskIsAllLoaded = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isTaskLoadingMore = _React$useState18[0],
    setTaskIsLoadingMore = _React$useState18[1];
  var _React$useState19 = React.useState({
      taskId: null,
      source: null // "dropdown" | "button"
    }),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    loadingAction = _React$useState20[0],
    setLoadingAction = _React$useState20[1];
  var _useMutation = useMutation(UPDATE_PERSONAL_TASK_STATUS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updatePersonalTaskStatus = _useMutation2[0],
    updatePersonalTaskLoading = _useMutation2[1].loading;

  //load more
  function handleTabScroll(e) {
    var element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      var _personalTaskData$get;
      if (personalTaskLoading) return;
      if (isTaskAllLoaded) return;
      setTaskIsLoadingMore(true);
      personalTaskFetchMore({
        variables: {
          offset: personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$get = personalTaskData.getPersonalTaskListing) === null || _personalTaskData$get === void 0 ? void 0 : _personalTaskData$get.length
        },
        updateQuery: function updateQuery(prev, _ref) {
          var fetchMoreResult = _ref.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if (fetchMoreResult.getPersonalTaskListing.length < LIMIT && !isTaskAllLoaded) {
            setTaskIsAllLoaded(true);
          }
          setTaskIsLoadingMore(false);
          var NewFilterData = [];
          fetchMoreResult.getPersonalTaskListing.forEach(function (newTask) {
            var found = prev.getPersonalTaskListing.find(function (item) {
              return item.taskId === newTask.taskId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newTask);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            getPersonalTaskListing: [].concat(_toConsumableArray(prev.getPersonalTaskListing), NewFilterData)
          });
        }
      });
    }
  }

  // status change
  var handleStatusSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(taskId, status, source) {
      var variables, _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!updatePersonalTaskLoading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            variables = {
              taskId: taskId,
              status: status,
              organisationId: organisationId
            };
            setLoadingAction({
              taskId: taskId,
              source: source
            });
            _context.prev = 4;
            _context.next = 7;
            return updatePersonalTaskStatus({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PERSONAL_TASK_DETAILS,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }, {
                query: PERSONAL_TASK_COUNT_DETAILS,
                variables: {
                  organisationId: organisationId,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }]
            });
          case 7:
            response = _context.sent;
            if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.updatePersonalTaskStatus) {
              _context.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            toast.success("Personal Task Status Updated successfully!");
            setLoadingAction({
              taskId: null,
              source: null
            });
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            toast.error("Error Occured, Try again later!");
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 14]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [updatePersonalTaskStatus, organisationId, filterPriorityId, filterStatusId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-task-table-wrapper"
  }, personalTaskLoading ? /*#__PURE__*/React.createElement(Loader, null) : personalTaskError ? /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.") : (personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$get2 = personalTaskData.getPersonalTaskListing) === null || _personalTaskData$get2 === void 0 ? void 0 : _personalTaskData$get2.length) == 0 ? /*#__PURE__*/React.createElement("p", {
    className: "emplyees-data-no"
  }, "No data found.") : /*#__PURE__*/React.createElement(Table, {
    className: "personal-task-table-whole"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task"), /*#__PURE__*/React.createElement("th", null, "Priority"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Due Date"), /*#__PURE__*/React.createElement("th", {
    className: "personal-task-text-center"
  }, "Actions"))), /*#__PURE__*/React.createElement("tbody", null, personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$get3 = personalTaskData.getPersonalTaskListing) === null || _personalTaskData$get3 === void 0 ? void 0 : _personalTaskData$get3.map(function (task) {
    var taskId = task.taskId,
      taskName = task.taskName,
      taskStatus = task.taskStatus,
      priority = task.priority,
      dueDate = task.dueDate,
      taskDueStatus = task.taskDueStatus;
    return /*#__PURE__*/React.createElement("tr", {
      key: taskId,
      className: "personal-task-tr-row ".concat(taskStatus === "completed" ? "completed" : "")
    }, /*#__PURE__*/React.createElement("td", {
      className: "personal-task-name"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("span", {
      className: "personal-task-name-p"
    }, taskName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "personal-task-priority-badge ".concat(priority)
    }, priority)), /*#__PURE__*/React.createElement("td", {
      className: "personal-task-width"
    }, /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      variant: "light",
      size: "sm",
      className: "personal-task-status-badge ".concat(taskStatus),
      disabled: loadingAction.taskId !== null
    }, /*#__PURE__*/React.createElement("span", null, taskStatus == "toDo" ? "ToDo" : taskStatus == "inProgress" ? "In Progress" : taskStatus == "onHold" ? "On Hold" : taskStatus == "completed" ? "Completed" : "-")), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
      disabled: loadingAction.taskId !== null,
      onClick: function onClick() {
        return handleStatusSubmit(taskId, "toDo", "dropdown");
      }
    }, loadingAction.taskId === taskId && loadingAction.source === "dropdown" ? /*#__PURE__*/React.createElement(Loader, null) : "To Do"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      disabled: loadingAction.taskId !== null,
      onClick: function onClick() {
        return handleStatusSubmit(taskId, "inProgress", "dropdown");
      }
    }, loadingAction.taskId === taskId && loadingAction.source === "dropdown" ? /*#__PURE__*/React.createElement(Loader, null) : "In Progress"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      disabled: loadingAction.taskId !== null,
      onClick: function onClick() {
        return handleStatusSubmit(taskId, "onHold", "dropdown");
      }
    }, loadingAction.taskId === taskId && loadingAction.source === "dropdown" ? /*#__PURE__*/React.createElement(Loader, null) : "On Hold"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      disabled: loadingAction.taskId !== null,
      onClick: function onClick() {
        return handleStatusSubmit(taskId, "completed", "dropdown");
      }
    }, loadingAction.taskId === taskId && loadingAction.source === "dropdown" ? /*#__PURE__*/React.createElement(Loader, null) : "Completed")))), /*#__PURE__*/React.createElement("td", {
      className: taskDueStatus == "Overdue" ? "personal-task-due-date-overdue" : ""
    }, dueDate ? moment.unix(Number(dueDate) / 1000).format("MMM DD, YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
      className: "personal-task-actions"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Mark as Completed")
    }, /*#__PURE__*/React.createElement(Button
    //className="personal-task-action-btn complete"
    , {
      className: "personal-task-action-btn ".concat(taskStatus == "completed" ? "completed" : "complete"),
      onClick: function onClick() {
        return handleStatusSubmit(taskId, "completed", "button");
      },
      disabled: loadingAction.taskId !== null
    }, loadingAction.taskId === taskId && loadingAction.source === "button" ? /*#__PURE__*/React.createElement(Loader, null) : "✓")), /*#__PURE__*/React.createElement("div", {
      className: "personal-task-action-btn-edit",
      onClick: function onClick() {
        handleShow(taskId, dueDate, taskName, taskStatus, priority);
      }
    }, /*#__PURE__*/React.createElement(FiEdit, null)), /*#__PURE__*/React.createElement("div", {
      className: "personal-task-action-btn-delete",
      onClick: function onClick() {
        return handleTaskDeleteShow(taskId);
      }
    }, /*#__PURE__*/React.createElement(RiDeleteBinLine, null))));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-details-task-management-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, personalTaskData !== null && personalTaskData !== void 0 && (_personalTaskData$get4 = personalTaskData.getPersonalTaskListing) !== null && _personalTaskData$get4 !== void 0 && _personalTaskData$get4.length ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, (personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$get5 = personalTaskData.getPersonalTaskListing) === null || _personalTaskData$get5 === void 0 ? void 0 : _personalTaskData$get5.length) < LIMIT || isTaskAllLoaded ? /*#__PURE__*/React.createElement("p", {
    className: "project-details-all-task-label"
  }, "You have seen all the task") : /*#__PURE__*/React.createElement(React.Fragment, null, isTaskLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick(e) {
      handleTabScroll(e);
    }
  }, "Load more"))) : null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)))));
};
var taskPriority = [{
  label: "Low",
  value: "low"
}, {
  label: "Medium",
  value: "medium"
}, {
  label: "High",
  value: "high"
}];
var taskStatus = [{
  label: "ToDo",
  value: "toDo"
}, {
  label: "In Progress",
  value: "inProgress"
}, {
  label: "On Hold",
  value: "onHold"
}, {
  label: "Completed",
  value: "completed"
}];
var AddTaskModal = function AddTaskModal(props) {
  var addTaskShow = props.addTaskShow,
    setAddTaskShow = props.setAddTaskShow,
    handleTaskClose = props.handleTaskClose,
    organisationId = props.organisationId,
    filterPriorityId = props.filterPriorityId,
    filterStatusId = props.filterStatusId;
  if (addTaskShow == null) {
    return null;
  }
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _React$useContext3 = React.useContext(FilterContext),
    organisationSettings = _React$useContext3.organisationSettings,
    role = _React$useContext3.role;
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    manualStartDate = _React$useState22[0],
    setManualStartDate = _React$useState22[1];
  var _useMutation3 = useMutation(ADD_PERSONAL_TASK_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addPersonalTaskDetails = _useMutation4[0],
    addPersonalTaskDetailsLoading = _useMutation4[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var taskName, priority, status, variables, _response$data2, response, _response$data3;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            taskName = values.taskName, priority = values.priority, status = values.status;
            variables = {
              taskName: taskName,
              organisationId: organisationId,
              dueDate: manualStartDate,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              priority: priority,
              status: status
            };
            _context2.prev = 2;
            _context2.next = 5;
            return addPersonalTaskDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PERSONAL_TASK_DETAILS,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }, {
                query: PERSONAL_TASK_COUNT_DETAILS,
                variables: {
                  organisationId: organisationId,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }]
            });
          case 5:
            response = _context2.sent;
            if (response && (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.addPersonalTaskDetails) != "error") {
              toast.success("Task added successfully!");
              handleTaskClose();
            } else {
              actions.setFieldError("taskName", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.addPersonalTaskDetails);
            }
            _context2.next = 12;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            actions.setFieldError("formError", _context2.t0.message);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [addPersonalTaskDetails, addPersonalTaskDetailsLoading, manualStartDate]);
  var handleChange = function handleChange(e) {
    setManualStartDate(e);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleTaskClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Create Personal Task")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: "",
      priority: "medium",
      status: "toDo"
    },
    validationSchema: personalTaskSchema,
    onSubmit: handleSubmit
  }, function (_ref4) {
    var setFieldValue = _ref4.setFieldValue,
      errors = _ref4.errors,
      touched = _ref4.touched,
      values = _ref4.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "my-projects-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Task Title"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, errors.formError && /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, errors.formError), /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "e.g. Mobile App Design",
        className: "my-projects-edit-project-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "personal-add-task-priority-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        required: true
      }, field), taskPriority === null || taskPriority === void 0 ? void 0 : taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "status"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Status"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        required: true
      }, field), taskStatus === null || taskStatus === void 0 ? void 0 : taskStatus.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-personal-task-modal-content-name"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "my-projects-modal-label-name"
    }, "Due Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker",
      placeholderText: "Select due date",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: addPersonalTaskDetailsLoading
    }, addPersonalTaskDetailsLoading ? "Loading..." : "Create Task"))))))));
  })));
};

// delete task
export var DeleteTaskModal = function DeleteTaskModal(props) {
  var showTaskDeleteModal = props.showTaskDeleteModal,
    handleTaskDeleteClose = props.handleTaskDeleteClose,
    organisationId = props.organisationId,
    filterPriorityId = props.filterPriorityId,
    filterStatusId = props.filterStatusId;
  if (showTaskDeleteModal === false) {
    return null;
  }
  var taskId = showTaskDeleteModal.taskId;
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    deleteStatus = _React$useState24[0],
    setDeleteStatus = _React$useState24[1];
  var _useMutation5 = useMutation(DELETE_TASK_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    deletePersonalTask = _useMutation6[0],
    deleteTaskLoading = _useMutation6[1].loading;
  var handleDeleteProject = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!deleteTaskLoading) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.next = 4;
            return deletePersonalTask({
              variables: {
                taskId: taskId,
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PERSONAL_TASK_DETAILS,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }, {
                query: PERSONAL_TASK_COUNT_DETAILS,
                variables: {
                  organisationId: organisationId,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }]
            });
          case 4:
            response = _context3.sent;
            if (!response || !response.data || !response.data.deletePersonalTask) {
              toast.success("Error, Try again");
            } else {
              handleTaskDeleteClose();
              toast.success("Task deleted successfully!");
              setDeleteStatus(true);
            }
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }, [deletePersonalTask, deleteTaskLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskDeleteModal,
    onHide: handleTaskDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Do you want to delete this task?"), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleTaskDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteProject(),
    disabled: deleteTaskLoading
  }, deleteTaskLoading ? "Loading" : deleteStatus === true ? "Deleted" : "Yes, Delete")));
};
// edit task
export var TaskModal = function TaskModal(props) {
  var taskDetails = props.taskDetails,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    filterPriorityId = props.filterPriorityId,
    filterStatusId = props.filterStatusId;
  if (taskDetails === false) return null;
  var taskId = taskDetails.taskId,
    dueDate = taskDetails.dueDate,
    taskName = taskDetails.taskName,
    taskStatuss = taskDetails.taskStatuss,
    priority = taskDetails.priority;
  var _React$useContext4 = React.useContext(FilterContext),
    organisationSettings = _React$useContext4.organisationSettings,
    role = _React$useContext4.role;
  var _React$useState25 = React.useState(dueDate ? Number(dueDate) : null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    manualStartDate = _React$useState26[0],
    setManualStartDate = _React$useState26[1];
  var _useMutation7 = useMutation(EDIT_TASK_DETAILS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    editPersonalTaskDetails = _useMutation8[0],
    editTaskDetailsLoading = _useMutation8[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!editTaskDetailsLoading) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return editPersonalTaskDetails({
              variables: {
                taskName: values.taskName,
                organisationId: organisationId,
                taskId: taskId,
                status: values.status,
                dueDate: moment(manualStartDate),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                priority: values.priority
              },
              refetchQueries: [{
                query: PERSONAL_TASK_DETAILS,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }, {
                query: PERSONAL_TASK_COUNT_DETAILS,
                variables: {
                  organisationId: organisationId,
                  priority: filterPriorityId,
                  status: filterStatusId
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context4.sent;
            if (!(!response || !response.data)) {
              _context4.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            handleClose();
            toast.success("Task updated successfully!");
          case 12:
            _context4.next = 16;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](2);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 14]]);
    }));
    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }(), [editPersonalTaskDetails, editTaskDetailsLoading, manualStartDate]);
  var handleChange = function handleChange(e) {
    setManualStartDate(e);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Edit Personal Task")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: taskName !== null && taskName !== void 0 ? taskName : "",
      priority: priority,
      status: taskStatuss
    },
    validationSchema: personalTaskSchema,
    onSubmit: handleSubmit
  }, function (_ref7) {
    var setFieldValue = _ref7.setFieldValue,
      errors = _ref7.errors,
      touched = _ref7.touched,
      values = _ref7.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "my-projects-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Task Title"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "e.g. Mobile App Design",
        className: "my-projects-edit-project-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "personal-add-task-priority-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        required: true
      }, field), taskPriority === null || taskPriority === void 0 ? void 0 : taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "status"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Status"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        required: true
      }, field), taskStatus === null || taskStatus === void 0 ? void 0 : taskStatus.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-personal-task-modal-content-name"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "my-projects-modal-label-name"
    }, "Due Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker",
      placeholderText: "Select due date",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
    }))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: editTaskDetailsLoading
    }, editTaskDetailsLoading ? "Loading..." : "Save Changes"))))))));
  })));
};